import PropTypes from 'prop-types';

import companiesStrings from 'modules/companies/strings';
import SectionDivider from 'modules/common/components/SectionDivider';

import {
  Wrapper,
  GridWrapper,
  CardWrapper,
  CompanyTitle,
  CompanyInfoWrapper,
  CompanyInfoSection,
  CompanyInfoText,
} from './CompaniesList.style';

const CompaniesList = ({ companiesListArr, handleCompanyClick }) => (
  <Wrapper>
    <GridWrapper>
      {companiesListArr.map(company => {
        const savedCompanyProfileKeyInSession = sessionStorage.getItem(
          'companyProfileKeyAuthCookie',
        );
        const isSelected = company.companyProfileKey === savedCompanyProfileKeyInSession;

        return (
          <CardWrapper
            key={company.companyProfileKey}
            selected={isSelected}
            onClick={() => handleCompanyClick(company)}
          >
            <CompanyTitle>
              {companiesStrings.companiesList.companiesListLabels.companyTitleLabel}
            </CompanyTitle>
            <SectionDivider gap={4} />
            <CompanyInfoWrapper>
              <CompanyInfoSection>
                <CompanyInfoText>
                  {companiesStrings.companiesList.companiesListLabels.companyNameLabel}
                </CompanyInfoText>
                <SectionDivider gap={4} />
                <CompanyInfoText>
                  {companiesStrings.companiesList.companiesListLabels.companyEmailLabel}
                </CompanyInfoText>
              </CompanyInfoSection>
              <CompanyInfoSection>
                <CompanyInfoText>{company.name}</CompanyInfoText>
                <SectionDivider gap={4} />
                <CompanyInfoText>{company.email}</CompanyInfoText>
              </CompanyInfoSection>
            </CompanyInfoWrapper>
          </CardWrapper>
        );
      })}
    </GridWrapper>
  </Wrapper>
);
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################
CompaniesList.propTypes = {
  companiesListArr: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleCompanyClick: PropTypes.func.isRequired,
};

CompaniesList.defaultProps = {};

export default CompaniesList;
